(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var triggers = document.querySelectorAll('[data-vtl-menu-trigger]');
    var menu = document.querySelector('[data-vtl-side-menu]');
    if (triggers.length && menu) {
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var open = menu.classList.toggle('is-open');
          triggers.forEach(function (t) { t.setAttribute('aria-expanded', open); });
        });
      });
    }
  });

  // Subtle scroll-in animation across the store: fades/lifts elements into
  // view once as the visitor scrolls. Fails silently and never hides
  // content if IntersectionObserver isn't supported or anything throws.
  // Hero benefit cards (Local Sellers / Global Shipping / VTL Official
  // Store, inside the main banner) are intentionally excluded -- they must
  // render fully visible immediately, no fade-in.
  document.addEventListener('DOMContentLoaded', function () {
    try {
      if (!('IntersectionObserver' in window)) return;
      // NOTE: 'main .shopify-section' was removed from this list -- it wrapped
      // the ENTIRE homepage content in one single reveal target, and on some
      // mobile browsers the IntersectionObserver callback never fired for it,
      // leaving the whole page blank below the header. That was the exact bug
      // reported live on mobile.
      var revealSelectors = [
        '.product-card',
        '.category-grid a',
        '.official-card',
        '.top-selling',
        '.why-card',
        '.b2b-card',
        '.b2b-card-promo',
        '.section-title',
        '.product-tabs',
        '.value-strip span',
        '.vtl-section-card',
        '.page-content',
        '.product-page__info',
        '.product-page__media',
        '.cart-page .cart-item',
        '.cart-summary',
        '.search-page',
        '.badge'
      ];
      var els = document.querySelectorAll(revealSelectors.join(','));
      if (!els.length) return;
      els.forEach(function (el, i) { el.classList.add('vtl-reveal'); el.style.transitionDelay = Math.min(i * 0.05, 0.4) + 's'; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('vtl-in-view');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { io.observe(el); });
      // Safety net: no matter what happens with the observer (browser quirk,
      // tab loaded in background, etc.), guarantee every revealed element
      // becomes fully visible within 2.5s so nothing can stay hidden forever.
      setTimeout(function () {
        els.forEach(function (el) { el.classList.add('vtl-in-view'); });
      }, 2500);
    } catch (e) {
      // never let an animation error break the page
    }
  });
})();

// --- Product page image gallery: a native touch-swipeable slider (finger
// drag moves smoothly between images via CSS scroll-snap) with dot
// indicators and clickable thumbnails that both animate the slider to the
// chosen image. Pure vanilla JS, no dependency on any image library.
// Fails silently if the markup isn't present (e.g. products with only
// one image render no slider controls at all).
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    try {
      var galleries = document.querySelectorAll('.product-gallery');
      galleries.forEach(function (gallery) {
        var main = gallery.querySelector('.product-gallery__main');
        var slides = gallery.querySelectorAll('.product-gallery__slide');
        var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
        var dots = gallery.querySelectorAll('.product-gallery__dot');
        if (!main || !slides.length) return;

        function setActive(index) {
          thumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.getAttribute('data-index')) === index); });
          dots.forEach(function (d) { d.classList.toggle('is-active', Number(d.getAttribute('data-index')) === index); });
        }

        function goTo(index) {
          var slide = slides[index];
          if (slide) main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          setActive(index);
        }

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            goTo(Number(thumb.getAttribute('data-index')));
          });
        });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goTo(Number(dot.getAttribute('data-index')));
          });
        });

        // Keep dots/thumbs synced while the visitor swipes the slider by hand.
        var scrollTimeout;
        main.addEventListener('scroll', function () {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(function () {
            var width = main.clientWidth || 1;
            var idx = Math.round(main.scrollLeft / width);
            if (idx < 0) idx = 0;
            if (idx > slides.length - 1) idx = slides.length - 1;
            setActive(idx);
          }, 80);
        }, { passive: true });
      });
    } catch (e) {
      // never let a gallery error break the page
    }
  });
})();

// --- Mobile fix: 3rd-party chat widget (Tidio) bubble sat too low and
// overlapped the fixed bottom tab bar's "Account" item on mobile.
//
// IMPORTANT: earlier versions of this fix nudged whatever fixed/absolute
// element sat directly under Tidio's shadow root. Tidio has since changed
// its internal markup (added a static wrapper div inside the shadow root),
// so that no longer finds anything. The one part of Tidio's integration
// that's a stable public contract is the widget HOST element itself
// (#tidio-chat, in the normal page DOM, not inside the shadow root) --
// Tidio keeps it position:fixed with bottom/right anchoring so the whole
// widget (launcher + panel) stays pinned to a corner. We nudge THAT,
// instead of reaching into Tidio's private, versioned shadow DOM, so this
// keeps working even if Tidio reshuffles what's inside the shadow root
// again. The size (scale) setting does need one specific element inside
// the shadow root (the small round launcher icon, which Tidio marks with
// a "chat-closed" class while collapsed) -- if Tidio ever renames that
// class, the size setting simply stops having a visible effect, but the
// position fix above is unaffected either way.
//
// DESKTOP-DISAPPEARING BUG (fixed here): Tidio anchors the host using its
// OWN inline bottom/right styles, not a stylesheet rule. The previous
// "reset to desktop" logic called style.removeProperty('bottom'/'right'),
// assuming that would fall back to Tidio's default corner. It actually
// stripped Tidio's only positioning rule: with both top and bottom left
// unset, a position:fixed element with height:100% resolves its "auto"
// position from its static (in-flow) position -- which on a long page can
// be thousands of pixels below the viewport, pushing the whole widget
// off-screen. That is exactly what was reported: the chat bubble invisible
// on desktop. Fix: capture Tidio's own natural bottom/right once (the
// first time we see a sane value) and restore THAT exact value on desktop
// instead of removing the property, falling back to '0px'/'0px' (Tidio's
// normal corner default) if a sane value was never captured.
(function () {
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
  }

  // Position/size come from theme settings (Theme editor > Theme settings >
  // Chat widget), rendered as CSS custom properties on :root by theme.liquid.
  function cssVarNumber(name, fallback) {
    try {
      var raw = window.getComputedStyle(document.documentElement).getPropertyValue(name);
      var n = parseFloat(raw);
      return isNaN(n) ? fallback : n;
    } catch (e) { return fallback; }
  }

  var naturalBottom = null;
  var naturalRight = null;

  function captureNatural(cs) {
    if (naturalBottom !== null) return;
    try {
      var b = parseFloat(cs.bottom);
      var r = parseFloat(cs.right);
      // Only trust values that look like a real corner anchor, not an
      // already-broken huge offset.
      if (!isNaN(b) && Math.abs(b) < 300) naturalBottom = cs.bottom;
      if (!isNaN(r) && Math.abs(r) < 300) naturalRight = cs.right;
    } catch (e) { /* ignore */ }
  }

  function nudgePosition(host) {
    try {
      var cs = window.getComputedStyle(host);
      if (cs.position !== 'fixed') return;

      captureNatural(cs);

      if (!isMobile()) {
        host.style.setProperty('bottom', naturalBottom || '0px');
        host.style.setProperty('right', naturalRight || '0px');
        return;
      }

      var bottom = parseInt(cs.bottom, 10);
      if (!isNaN(bottom) && bottom < 70) {
        var bottomOffset = cssVarNumber('--tidio-bottom', 104);
        host.style.setProperty('bottom', 'calc(' + bottomOffset + 'px + env(safe-area-inset-bottom))', 'important');
      }

      var rightOffset = cssVarNumber('--tidio-right', 0);
      if (rightOffset > 0) {
        var right = parseInt(cs.right, 10);
        if (!isNaN(right)) {
          host.style.setProperty('right', 'calc(' + (right + rightOffset) + 'px + env(safe-area-inset-right))', 'important');
        }
      }
    } catch (e) { /* ignore */ }
  }

  var trackedBubble = null;

  function applyScale(host) {
    try {
      if (!host.shadowRoot) return;

      if (!trackedBubble || !host.shadowRoot.contains(trackedBubble)) {
        var found = host.shadowRoot.querySelector('[class*="chat-closed"],[class*="chat-open"]');
        if (found && found !== trackedBubble) {
          trackedBubble = found;
          try {
            var mo = new MutationObserver(function () {
              var h = document.getElementById('tidio-chat');
              if (h) applyScale(h);
            });
            mo.observe(trackedBubble, { attributes: true, attributeFilter: ['class'] });
          } catch (e) { /* ignore */ }
        }
      }
      if (!trackedBubble) return;

      var scalePct = cssVarNumber('--tidio-scale', 100);
      var isClosed = /(^|\s)chat-closed(\s|$)/.test(trackedBubble.className || '');

      if (isMobile() && isClosed && scalePct && scalePct !== 100) {
        trackedBubble.style.setProperty('transform', 'scale(' + (scalePct / 100) + ')', 'important');
        trackedBubble.style.setProperty('transform-origin', 'bottom right', 'important');
      } else {
        trackedBubble.style.removeProperty('transform');
        trackedBubble.style.removeProperty('transform-origin');
      }
    } catch (e) { /* ignore */ }
  }

  function sweep() {
    var host = document.getElementById('tidio-chat');
    if (!host) return false;
    nudgePosition(host);
    applyScale(host);
    return true;
  }

  function init() {
    sweep();
    // Tidio loads asynchronously; keep checking briefly until the widget
    // (and its inner shadow DOM) is fully rendered.
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      sweep();
      if (attempts > 15) clearInterval(timer);
    }, 1000);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  window.addEventListener('resize', function () { try { sweep(); } catch (e) {} });
})();
